/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import { useEffect } from "react";

const Banner = ({ ...props }) => {

	useEffect(() => {
		try {
			reviveAsync['0cceecb9cae9f51a31123c541910d59b'].refresh()
		} catch (e) {
			if (process.env.NODE_ENV !== 'production') {
				console.log('Error: ', e)
			}
		}
		try {
			if (
				props.dataAds &&
				props.dataAds !== ' ' &&
				typeof refreshSlotDfp === 'function'
			) {
				refreshSlotDfp(props.name)
			}
		} catch (e) {
			if (process.env.NODE_ENV !== 'production') {
				console.error('error refreshSlotDfp: ', e)
			}
		}
	})

	return (
    <>
      <div
        id={props.component_id}
        className={props.class_name || ''}
        dangerouslySetInnerHTML={{
          __html: props.dataAds,
        }}
      />

      <style jsx>
        {`
          .ads-mediumrectangle1 {
            display: flex;
            justify-content: center;
          }
          .ads-mediumrectangle2-detail {
            display: flex;
            justify-content: center;
            margin: 0 0 24px 0;
          }
          .ads-mediumrectangle3 {
            display: flex;
            justify-content: center;
          }
          .bottomframe {
            bottom: -4px;
            left: 0px;
            position: fixed;
            right: 0px;
            text-align: center;
            z-index: 3;
          }
          .ads-billboard {
            padding: 20px 0;
            height: ${props.is_mobile ? '100px' : '250px'};
            display: flex;
            justify-content: center;
          }
          .billboard-home {
            margin: 66px 0 0 0;
            text-align: center;
          }
          .horizontal-home {
            margin: 16px 0 20px 0;
          }
          .banner-1-mobile {
            text-align: center;
          }
          .mobile-staticbanner2 {
            margin-top: 16px;
          }
          .ads-static-3 {
            text-align: center;
            margin: 0;
          }
          .topframe {
            position: sticky;
            top: 0px;
            left: 0;
            right: 0;
            z-index: 2;
            display: flex;
            justify-content: center;
            height: 50px;
          }
        `}
      </style>
    </>
  )

};

export default Banner;
